import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IModel } from "./LegalTaskManagement";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { baseUrl, Fetch } from "../../shared/Fetch";
import LegalTaskHistory from "../showPurchaseOrder/LegalTaskHistory";
import { Dialog } from "primereact/dialog";
import { useForm } from "react-hook-form";
import { IUsersDropdown } from "../../models/IDropdown";
import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILegalTeamMast } from "../legalTeamManagment/Table";
import { InputTextarea } from "primereact/inputtextarea";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Accordion, AccordionTab } from "primereact/accordion";
import Filter, { EmptyFilterLegalTask, IFilterLegalTask } from "./Filter";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { Toolbar } from "primereact/toolbar";
import { LegalTask } from "../showPurchaseOrder/LegalTask";
import Form from "./Form";
import { LegalTaskFromDetails } from "./LegalTaskFromDetails";
import { LegalTaskComments } from "./LegalTaskComments";

interface IProps {
  taskId: number,
  setModal: (modal: IModel) => void;
  toast: any;
  permissions: IPermissionProps;
  reload: boolean;
}

interface IStatusForm {
  status: string | null;
}

const statusSchema = yup.object({
  status: yup.string().required("Status is required"),
});

// interface ILegal_Tasks {
//   assignedBy?: string;
//   assignedTo?: string;
//   assigned_To?: number;
//   assignee_Action_Reason?: string;
//   assignee_Action_Status?: boolean;
//   consultant?: string;
//   created_At?: Date | string;
//   created_By?: string;
//   document_Name?: string;
//   document_Type?: string;
//   pO_Date?: Date | string;
//   pO_ID?: number;
//   pO_Status?: string;
//   recruiter?: string;
//   reqId?: number;
//   saleManger?: string;
//   status?: string;
//   task_Id?: number;
//   task_Name?: string;
//   assigned_At?: string;
//   assigne_Action_At?: string;
//   can_Assign?: boolean;
//   description?: string;
//   sourceType?: string,
// }

export interface ILegal_Tasks {
  id?: number;
  sourceType?: string;
  task_For_ID?: number;
  others?: string;
  req_ID?: number;
  pO_ID?: number;
  task_Name?: string;
  description?: string;
  document_Type?: string;
  document_Name?: string;
  status?: string;
  assigned_To?: number;
  assigned_At?: Date;
  assignedTo?: string;
  assignee_Action_Status?: boolean;
  assignee_Action_Reason?: string;
  assigned_By_ID?: 1;
  assigned_By_Name?: string;
  created_At?: Date;
  created_By_ID?: 1;
  created_By?: string;
  can_Assign?: boolean;
  priority?: string;
  can_Approve?: boolean;
}

const Table = (props: IProps) => {
  const [historyModal, setHistoryModal] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState<number | null>(null);
  const [openAssigned, setOpenAssigned] = useState({ open: false, singleData: {} } as { open: boolean; singleData: ILegal_Tasks });
  const [legal_Team, setLegal_Team] = useState<ILegalTeamMast[]>([]);
  const [legalUsers, setLegalUsers] = useState<IUsersDropdown[]>([]);
  const [selectedTask, setSelectedTask] = useState<any>(null);
  const [statusModal, setStatusModal] = useState({ open: false, row: null } as { open: boolean, row: any });
  const [filters, setFilters] = useState<IFilterLegalTask>(EmptyFilterLegalTask);
  const [approvalDialog, setApprovalDialog] = useState({ open: false, rowData: null as any, action: null as "approve" | "reject" | null, reason: "" });
  const [supportiveDoc, setSupportiveDoc] = useState<File | any | null>(null);
  const [supportiveDocText, setSupportiveDocText] = useState<string>("");
  const [statusCounts, setStatusCounts] = useState<Array<{ status?: string; count?: number }>>([]);
  const [descriptionDialog, setDescriptionDialog] = useState({ visible: false, description: "" });
  const [reasonDialog, setReasonDialog] = useState({ visible: false, reason: "", title: "" });
  const [taskTypeDialog, setTaskTypeDialog] = useState(false);
  const [poList, setPoList] = useState<any[]>([]);
  const [reqList, setReqList] = useState<any[]>([]);
  const [showLegalTaskForm, setShowLegalTaskForm] = useState(false);
  const [fromTaskModal, setFromTaskModal] = useState({ open: false, singleData: {} } as { open: boolean; singleData: ILegal_Tasks });
  const [taskComments, setTaskComments] = useState({ open: false, singleData: {} } as { open: boolean; singleData: ILegal_Tasks });

  const dt = useRef<any>(null);
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ILegal_Tasks>; loading: boolean });
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;
  const roles = loginObj.roles.map((r: any) => r.role_ID);
  const loginId = loginObj.id;

  const { control, handleSubmit, formState: { errors: error, isDirty }, reset, watch } = useForm<{ team_ID: number, AssignedTo: number, task_Type?: any, po_ID?: any, req_ID?: any }>({
    resolver: yupResolver(yup.object({ team_ID: yup.number().required("Team is required"), AssignedTo: yup.number().required("Assigne is required") })),
    defaultValues: { team_ID: 0, AssignedTo: 0, task_Type: null, po_ID: null, req_ID: null },
    shouldFocusError: false
  });

  const {
    control: statusControl,
    handleSubmit: handleStatusSubmit,
    setValue: setStatusValue,
    reset: resetStatus,
    formState: { errors },
  } = useForm<IStatusForm>({
    resolver: yupResolver(statusSchema),
    defaultValues: { status: "" },
    shouldFocusError: false
  });

  const fileUploade = async (event: FileUploadHandlerParam) => {
    if (event.files[0].size > 1024000) {
      props.toast.current.show({ severity: "error", content: "Document should be less than 2 MB." });
      event.options.clear();
    } else {
      props.toast.current.show({ severity: "success", content: "Document Selected." });
      const file = event.files[0];
      setSupportiveDoc(file);
    }
  };

  const saveStatus = async (data: IStatusForm) => {
    if (data.status === statusModal.row.status && supportiveDoc === null && supportiveDocText.trim() === "") {
      props.toast.current.show({ severity: "warn", summary: "Warning", detail: "To Update Task, Need To Change Status or add a comment or upload a supportive file" });
      return;
    } else if (data.status === "Closed" && statusModal.row.status !== "Approved") {
      props.toast.current.show({ severity: "warn", summary: "Warning", detail: "Task Can Not be Marked as Task Completed untill approved" });
      return;
    }
    if ((statusModal.row.status === "Escalated" || statusModal.row.status === "Completed") && statusModal.row.can_Approve === false) {
      props.toast.current.show({ severity: "warn", summary: "Warning", detail: "only Management can do changes now" });
      return;
    }
    const formData = new FormData();
    formData.append("spDoc", supportiveDoc);
    const forBody: any = { ...data, Task_Id: statusModal.row?.id, supportive_Text: supportiveDocText };
    formData.append("body", JSON.stringify(forBody));
    const params = {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
      body: formData,
    };

    const response = await fetch(`${baseUrl}Legal_Task/updateStatus`, params);

    if (response.status === 404) {
      const message = await response.text();
      props.toast.current.show({ severity: "error", detail: message, life: 3000 });
      return;
    }
    if (response.status === 400) {
      const message = await response.text();
      props.toast.current.show({ severity: "error", detail: message, life: 3000 });
      return;
    }

    if (response.ok) {
      props.toast.current.show({ severity: "success", detail: "Status Updated Successfully", life: 3000 });
      setStatusModal({ open: false, row: null });
      resetStatus();
      setSupportiveDoc(null);
      setSupportiveDocText("");
      loadTableData();
    }

    setStatusModal({ open: false, row: null });
    resetStatus();
  };

  const openApprovalDialog = (rowData: any, action: "approve" | "reject") => {
    setApprovalDialog({
      open: true,
      rowData,
      action,
      reason: "",
    });
  };
  const saveApproval = async () => {
    if (approvalDialog.action === "reject" && (approvalDialog.reason === undefined || approvalDialog.reason === null || approvalDialog.reason.trim() === "")) {
      props.toast.current.show({
        severity: "error",
        detail: "Reject Reason is required",
      });
      return;
    }

    const response = await Fetch("Legal_Task/approve", "POST", { taskId: approvalDialog.rowData.id, action: approvalDialog.action, reason: approvalDialog.reason }, null, props.toast);

    if (response?.ok) {
      props.toast.current.show({ severity: "success", detail: `Task ${approvalDialog.action === "approve" ? "approved" : "rejected"} successfully` });

      setApprovalDialog({ open: false, rowData: null, action: null, reason: "" });

      loadTableData();
    }
  };

  const loadTeam = async () => {
    const response = await Fetch("LegalTeam_Mast/getAllLegalTeams", "GET", null, null, props.toast);

    if (response) {
      const data = await response.json();
      setLegal_Team(data);
    }
  };

  const loadLegalUsers = async (companyId: number, branchId: number, teamId: number) => {
    let query = "";
    if (teamId !== undefined && teamId !== null && teamId > 0) {
      query = `team_ID=${teamId}`;
    } else if (branchId !== undefined && branchId !== null && branchId > 0) {
      query = `branch_ID=${branchId}`;
    } else if (companyId !== undefined && companyId !== null && companyId > 0) {
      query = `company_ID=${companyId}`;
    }

    const response = await Fetch("Legal_Task/legalUsers", "GET", null, query, props.toast);

    if (response) {
      const data = await response.json();
      setLegalUsers(data);
    }
  };
  const openAssignDialog = (rowData: any) => {
    setOpenAssigned({ open: true, singleData: rowData });
  };
  useEffect(() => {
    loadTeam();
  }, []);

  const teamId = watch("team_ID");

  useEffect(() => {
    if (teamId) {
      loadLegalUsers(0, 0, teamId);
    }
  }, [teamId]);

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Legal Task Management</h5>
    </div>
  );
  const loadTableData = async () => {
    setTableData((prev) => ({ ...prev, loading: true }));

    try {
      const response = await Fetch("Legal_Task/getLegalTask", "GET", null, `filter=${JSON.stringify(filters)}`, props.toast);

      if (response && response.ok) {
        const data = await response.json();

        setTableData({ tableData: data, loading: false });
      }
    } catch (error) {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };

  const openHistory = (taskId: number) => {
    setSelectedTaskId(taskId);
    setHistoryModal(true);
  };

  const onHide = () => {
    reset({
      team_ID: 0,
      AssignedTo: 0,
    });
    setOpenAssigned({ open: false, singleData: {} });
  };

  const onSave = async (data: any) => {
    if (data.AssignedTo === 0 || data.AssignedTo === null) {
      props.toast.current.show({ severity: "error", summary: "error", detail: "Please Select a Assignee" });
    } else {
      const response = await Fetch("Legal_Task/assign", "POST",
        {
          taskId: openAssigned.singleData.id,
          assignedTo: data.AssignedTo,
        }, null, props.toast,);

      if (response?.ok) {
        props.toast.current.show({ severity: "success", summary: "Success", detail: "Task assigned successfully" });
        setOpenAssigned({ open: false, singleData: {} });
        setSelectedTask(null);
        loadTableData();
      }
    }
  };

  useEffect(() => {
    loadTableData();
    loadStatusCounst();
  }, [props.reload, filters]);

  const StatusOptions = [
    // { name: "Pending", value: "Pending" },
    // { name: "Assigned", value: "Assigned" },
    { name: "Received", value: "Received" },
    { name: "Under Review", value: "Under Review" },
    { name: "Fizzled Out", value: "Fizzled Out" },
    { name: "Negotiation in Progress", value: "Negotiation in Progress" },
    { name: "Documentation Pending", value: "Documentation Pending" },
    { name: "Executed", value: "Executed" },
    { name: "Escalated", value: "Escalated" },
    { name: "Completed", value: "Completed" },
    { name: "Approved", value: "Approved" },
    { name: "Rejected", value: "Rejected" },
    { name: "Closed", value: "Closed" },
  ];

  const loadStatusCounst = async () => {
    const resp = await Fetch("Legal_Task/getCounts", "GET", null, null, props.toast);
    if (resp) {
      const data: { status?: string; count?: number }[] = await resp?.json();
      setStatusCounts(data);
    }
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        {statusCounts.map((el: { status?: string; count?: number }) => (
          <Button label={el.status + " → " + el.count} className="mr-1" />
        ))}
      </React.Fragment>
    );
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </React.Fragment>
    );
  };

  const openNew = () => {
    setTaskTypeDialog(true);
  };

  const TaskTypeOptions = [
    { name: "From PO", value: 1 },
    { name: "From Req", value: 2 },
    { name: "Other", value: 3 },
  ];

  const PriorityOptions = [
    { name: "Low", value: 1 },
    { name: "Medium", value: 2 },
    { name: "High", value: 3 },
  ];

  const openTaskFromDetails = (data: ILegal_Tasks) => {
    setFromTaskModal({ open: true, singleData: data });
  };
  const priorityLabel = (val: number | undefined) => {
    return PriorityOptions.find((p: any) => p.value === val)?.name ?? val ?? "";
  };

  const priorityBody = (row: any) => {
    const bgColor = row.priority === 1 ? "#28A745" : row.priority === 2 ? "#FFC107" : row.priority === 3 ? "#DC3545" : "#6C757D";

    return (
      <span
        style={{
          backgroundColor: bgColor,
          color: "#fff",
          padding: "4px 8px",
          borderRadius: "12px",
          fontSize: "12px",
        }}
      >
        {priorityLabel(row.priority)}
      </span>
    );
  };

  const openComments = (data: ILegal_Tasks) => {
    return <span onClick={() => setTaskComments({ open: true, singleData: data })} className="pi cursor-pointer underline" style={{ color: "var(--primary-color)" }}>Comments</span>
  }

  useEffect(() => {
    if (props.taskId !== 0) {
      setTaskComments({ open: true, singleData: { id: props.taskId } });
    }
  }, [props.taskId]);

  return (
    <>
      <Toolbar className="mb-1 py-0" right={rightToolbarTemplate} left={leftToolbarTemplate}></Toolbar>
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filters={filters} setFilters={(filters: IFilterLegalTask) => setFilters(filters)} />
        </AccordionTab>
      </Accordion>
      <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }} size="small" stripedRows showGridlines responsiveLayout="scroll" value={tableData.tableData} header={header} loading={tableData.loading} ref={dt}>
        <Column header="SN" body={(rowData, { rowIndex }) => rowIndex + 1} />
        <Column field="sourceType" header="Task Source" />
        <Column
          field="task_For_ID"
          header="Req ID"
          body={(rowData: ILegal_Tasks) => (
            <p>
              {rowData.sourceType !== "OTHER" ? (
                <span className="pi cursor-pointer underline" style={{ color: "var(--primary-color)" }} onClick={() => openTaskFromDetails(rowData)}>
                  {rowData.task_For_ID}
                </span>
              ) : (
                <Button className="bg-white border-white text-black-alpha-90" tooltip={rowData?.others || ""}>
                  -
                </Button>
              )}
            </p>
          )}
        />
        <Column field="consultant_Name" header="Consultant Name" />
        <Column field="task_Name" header="Task Name" />
        <Column
          header="Description"
          body={(rowData: ILegal_Tasks) =>
            rowData.description ? (
              <i className="pi cursor-pointer underline" style={{ color: "var(--primary-color)" }} onClick={() => setDescriptionDialog({ visible: true, description: rowData?.description || "" })}>
                View Description
              </i>
            ) : (
              "-"
            )
          }
        />
        <Column field="document_Type" header="Document Type" />
        <Column field="document_Name" header="Document Name" />
        <Column field="priority" header="Priority" body={priorityBody} />
        <Column
          header="Status"
          body={(rowData: ILegal_Tasks) => {
            return rowData?.assigned_To === undefined || rowData?.assigned_To === null ? (
              <b> Created</b>
            ) : (rowData?.status === "Closed" && !(roles.includes(1) || roles.includes(26)) ? (
              <p onClick={() => props.toast.current.show({ severity: "warn", summary: "Warning", detail: "Closed" })}>{rowData?.status || ""}</p>
            ) : ((rowData?.status === "Escalated" || rowData?.status === "Completed") && !rowData.can_Approve ? (
              <p onClick={() => props.toast.current.show({ severity: "warn", summary: "Warning", detail: "you can do changes now" })}>{rowData?.status || ""}</p>
            ) : ((rowData?.assignee_Action_Status === true) ? (
              <span
                className={((roles.includes(1) || roles.includes(26) || rowData.assigned_To === loginObj.id) || ((rowData?.status === "Escalated" || rowData?.status === "Completed") && rowData.can_Approve)) ? "cursor-pointer text-cyan-700 underline" : ""}
                onClick={() => {
                  if ((roles.includes(1) || roles.includes(26) || rowData.assigned_To === loginObj.id)) {
                    setStatusValue("status", rowData?.status || "");
                    setStatusModal({ open: true, row: rowData });
                  } else if ((rowData?.status === "Escalated" || rowData?.status === "Completed") && rowData.can_Approve) {
                    setStatusValue("status", rowData?.status || "");
                    setStatusModal({ open: true, row: rowData });
                  } else props.toast.current.show({ severity: "warn", summary: "Warning", detail: "Can't Update Status" })
                }}
              >
                {rowData?.status !== "Pending" ? rowData?.status : "Assigned"}
              </span>
            ) : ((rowData?.assignee_Action_Status === undefined || rowData?.assignee_Action_Status === null) ? (
              <b>Waiting For Assigne For Acceptance</b>
            ) : (rowData?.assignee_Action_Status === false ? (
              <p>Task will be reassign</p>
            ) : (
              <p>Task Created, Not Yet Assigned</p>
            ))))));
          }}
        />
        <Column field="assignedTo" header="Assigned To" />
        <Column
          header="Assignee Action"
          style={{ minWidth: "250px" }}
          body={(rowData: ILegal_Tasks) => {
            const pending = rowData?.assignee_Action_Status === null || rowData?.assignee_Action_Status === undefined;

            const rejected = rowData?.assignee_Action_Status === false;

            if (rejected) {
              return (
                <div className="flex flex-column gap-1">
                  <span className="font-bold" style={{ color: "red" }}>
                    ✘ Rejected
                  </span>

                  {rowData.assignee_Action_Reason && (
                    <span
                      className="mt-1 p-button-sm p-link text-blue-500 cursor-pointer"
                      onClick={() =>
                        setReasonDialog({
                          visible: true,
                          reason: rowData.assignee_Action_Reason || "",
                          title: "Rejection Reason",
                        })
                      }
                    >
                      View Reason
                    </span>
                  )}
                </div>
              );
            }

            if (!pending) {
              return <span className="text-green-500 font-bold w-full">✔ Accepted</span>;
            }

            if (rowData.assigned_To === loginId) {
              return (
                <div className="flex flex gap-2">
                  <Button tooltip="Accept" icon="pi pi-check" className="p-button-success p-button-sm" onClick={() => openApprovalDialog(rowData, "approve")} />
                  <Button tooltip="Reject" icon="pi pi-times" className="p-button-danger p-button-sm" onClick={() => openApprovalDialog(rowData, "reject")} />
                </div>
              );
            }

            const diffMs = new Date().getTime() - new Date(rowData.assigned_At || "").getTime();

            const totalMinutes = Math.floor(diffMs / (1000 * 60));

            return (
              <span className="text-yellow-500 font-bold flex w-full">
                <span>⏳ Pending</span> {rowData.assigned_At !== null && <p>{`( ${totalMinutes}m )`}</p>}
              </span>
            );
          }}
        />
        <Column field="assigned_By_Name" header="Assigned By" />
        <Column field="created_At" header="Created At" style={{ minWidth: "7rem" }} body={(rowData: any) => <span>{safeFormatDate(rowData.created_At, "dd/MM/yyyy", DateFormat)}</span>} />
        <Column field="created_By" header="Created By" />
        <Column field="" header="Comments" body={openComments} />
        <Column
          header="History"
          body={(rowData: ILegal_Tasks) => (
            <span className="cursor-pointer" onClick={() => openHistory(rowData.id || 0)}>
              <i className="pi pi-history" style={{ color: "var(--primary-color)" }} />
            </span>
          )}
        />
        <Column
          header="Action"
          body={(rowData: ILegal_Tasks) =>
            (rowData.can_Assign === true && ((roles.includes(1) || roles.includes(26)) || rowData.status !== "Closed")) ? (
              <span className="cursor-pointer" onClick={() => openAssignDialog(rowData)}>
                <i className="pi pi-pencil" style={{ color: "var(--primary-color)" }} />
              </span>
            ) : (
              <></>
            )
          }
        />
      </DataTable>
      {/* Assign TasK */}
      <Dialog visible={openAssigned.open} modal header="Assign Task" style={{ width: "80vw" }} onHide={onHide}>
        <form onSubmit={handleSubmit(onSave)}>
          <div className="p-fluid formgrid grid">
            <JVDropdown column={3} label="Team" control={control} name="team_ID" options={legal_Team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Legal Team" error={error.team_ID?.message} />
            <JVDropdown column={3} label="Assigned To" control={control} name="AssignedTo" options={legalUsers} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Legal User" error={error.AssignedTo?.message} />

            <div className="col-12 flex justify-content-end gap-2">
              <Button
                type="button"
                label="Clear"
                className="p-button-outlined"
                onClick={() =>
                  reset({
                    team_ID: 0,
                    AssignedTo: 0,
                  })
                }
              />

              <Button type="submit" label="Save" />
            </div>
          </div>
        </form>
      </Dialog>
      {/* Approval Dialog */}
      <Dialog
        visible={approvalDialog.open}
        modal
        onHide={() =>
          setApprovalDialog({
            open: false,
            rowData: null,
            action: null,
            reason: "",
          })
        }
        header={approvalDialog.action === "approve" ? "Approve Task" : "Reject Task"}
        style={{ width: "25vw" }}
      >
        <p>Are You Sure You {approvalDialog.action === "approve" ? "Can" : "Can Not"} Complete This Task</p>

        <div>
          <label>{approvalDialog.action === "approve" ? "Remark If Any" : "Reject Reason"}</label>
          <InputTextarea
            value={approvalDialog.reason}
            onChange={(e: any) =>
              setApprovalDialog((prev) => ({
                ...prev,
                reason: e.target.value,
              }))
            }
            rows={3}
            className="w-full"
            placeholder="Enter Comment"
          />
        </div>

        <div className="flex justify-content-end mt-3">
          <Button label={approvalDialog.action === "approve" ? "Accept" : "Reject"} onClick={saveApproval} />
        </div>
      </Dialog>
      {/* Reason Block */}
      <Dialog
        visible={reasonDialog.visible}
        modal
        header={reasonDialog.title}
        style={{ width: "30vw" }}
        onHide={() =>
          setReasonDialog({
            visible: false,
            reason: "",
            title: "",
          })
        }
      >
        <p>{reasonDialog.reason}</p>
      </Dialog>
      {/* Status Dialog   */}
      <Dialog
        visible={statusModal.open}
        header="Update Status"
        style={{ width: "30vw" }}
        modal
        onHide={() => {
          setStatusModal({ open: false, row: null });
          setSupportiveDoc(null);
          setSupportiveDocText("");
          resetStatus();
        }}
      >
        <form onSubmit={handleStatusSubmit(saveStatus)}>
          <div className="p-fluid formgrid grid">
            <JVDropdown
              column={2}
              label="Status"
              control={statusControl}
              name="status"
              options={(roles.includes(1) || roles.includes(26)) ? StatusOptions : (statusModal.row?.status === "Approved" ? StatusOptions.filter((el: any) => el.name === "Closed") : (statusModal.row?.status === "Completed" ? StatusOptions.filter((fl: any) => fl.name === "Approved" || fl.name === "Rejected") : StatusOptions.filter((fl: any) => fl.name !== "Approved" && fl.name !== "Rejected" && fl.name !== "Closed")))}
              optionLabel="name"
              optionValue="value"
              error={errors.status?.message}
            />
            <div className="field col-12 md:col-6">
              <label htmlFor="file">Supportive Document</label>
              <FileUpload chooseLabel="Choose Document" mode="basic" name="file" accept="*" maxFileSize={10000000} auto customUpload uploadHandler={fileUploade} />
            </div>
            <div className="field col-12 md:col-12">
              {/* <label htmlFor="file">Supportive Reason<span style={{ color: 'red' }}>*</span></label> */}
              <label htmlFor="file">Supportive Reason</label>
              <InputTextarea value={supportiveDocText} onChange={(e) => setSupportiveDocText(e.target.value)} rows={5} cols={30} />
            </div>
            <div className="field col-12 flex justify-content-end gap-2">
              <Button label="Save" icon="pi pi-check" type="submit" />
              <Button label="Clear" icon="pi pi-times" type="button" className="p-button-secondary" onClick={() => setStatusValue("status", "")} />
            </div>
          </div>
        </form>
      </Dialog>
      {/* History Table */}

      <LegalTaskHistory
        visible={historyModal}
        taskId={selectedTaskId}
        toast={props.toast}
        onHide={() => {
          setHistoryModal(false);
          setSelectedTaskId(null);
        }}
      />
      {/* Description Box */}
      <Dialog header="Task Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
      {/* New Task */}

      <Form
        open={taskTypeDialog}
        hideDialog={() => {
          setTaskTypeDialog(false);
          setShowLegalTaskForm(false);
        }}
        toast={props.toast}
        reload={props.reload}
        loadTableData={() => loadTableData()}
        setReload={() => loadTableData()}
      />
      <LegalTaskFromDetails open={fromTaskModal.open} data={fromTaskModal.singleData} hideDialog={() => setFromTaskModal({ open: false, singleData: {} })} toast={props.toast} />
      <LegalTaskComments open={taskComments.open} singleData={taskComments.singleData} hideDialog={() => setTaskComments({ open: false, singleData: {} })} toast={props.toast} />
    </>
  );
};

export default Table;
